import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Link from 'next/link';
import { useState, useEffect } from 'react';

import { popover } from '@/styles/popover';

import { CheckCircleIcon } from '@/ui/Icons/CheckCircleIcon';
import { CopyIcon } from '@/ui/Icons/CopyIcon';
import { DownloadIcon } from '@/ui/Icons/DownloadIcon';
import { Logo } from '@/ui/Logo/Logo';
import { LogoCup } from '@/ui/Logo/LogoCup';

import { routes } from '@/utils/routes';

import { classNames } from '../../../utils/classnames';
import { LOGO_SVG } from './constants';

const TWO_SECONDS = 2000;
const popoverStyles = popover();

export const MatchaLogoButton = () => {
  const [isCopied, setIsCopied] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (isCopied) {
      timeout = setTimeout(() => {
        setIsCopied(false);
      }, TWO_SECONDS);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isCopied]);

  const handleCopyLogo = async () => {
    if (isCopied) return;
    await navigator.clipboard.writeText(LOGO_SVG);
    setIsCopied(true);
  };

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger asChild>
        <div
          onContextMenu={(e) => {
            e.preventDefault();
            setOpen(true);
          }}
          onPointerDown={(e) => e.button === 0 && e.preventDefault()}
          className={classNames(
            'group',
            'flex',
            'items-center',
            'tablet:min-w-fit',
            'grow-0',
            'basis-1',
            'text-token-gray-1600',
            'transition-transform',
            'duration-200',
            'ease-[cubic-bezier(0.4,0,0,1)]',
            'hover:scale-102',
          )}
        >
          <Link
            aria-label="Go to homepage"
            href={{ pathname: routes.INDEX }}
            className="flex items-center gap-[11px]"
          >
            <LogoCup
              className={
                'transition-colors duration-500 ease-in-out group-hover:text-primitive-green-900 text-primitive-green-900'
              }
              height={24}
            />
            <Logo className="hidden tablet:block mb-0.5" height={16} />
          </Link>
        </div>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="start"
          side="bottom"
          className={classNames(popoverStyles.base(), '[&>*:last-child]:mb-0')}
        >
          <DropdownMenu.Item
            className={popoverStyles.item()}
            onSelect={(e) => {
              e.preventDefault();
              handleCopyLogo();
            }}
          >
            {isCopied ? (
              <>
                <CheckCircleIcon className={popoverStyles.icon()} />
                Copied!
              </>
            ) : (
              <>
                <CopyIcon className={popoverStyles.icon()} />
                Copy Logo as SVG
              </>
            )}
          </DropdownMenu.Item>
          <DropdownMenu.Item
            className={popoverStyles.item()}
            onSelect={() => window.open(routes.BRAND_ASSETS, '_blank')}
          >
            <DownloadIcon className={popoverStyles.icon()} />
            Download Brand Assets
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
